<script setup>
import { ref } from 'vue';
import { Swiper, SwiperSlide } from 'swiper/vue';
import {Pagination, Autoplay} from 'swiper/modules';

import 'swiper/css';
import 'swiper/css/pagination';

const props = defineProps({
  gallery: {
    type: Array,
    default: () => []
  },
});

const modules = [Pagination, Autoplay];

const isModalOpen = ref(false);
const selectedImage = ref('');

const openModal = (url) => {
  selectedImage.value = url;
  isModalOpen.value = true;
  document.body.style.overflow = 'hidden';
};

const closeModal = () => {
  isModalOpen.value = false;
  selectedImage.value = '';
  document.body.style.overflow = 'auto';
};

const swiperOptions = {
  slidesPerView: 1,
  spaceBetween: 10,
  loop: true,
  breakpoints: {
    640: {
      slidesPerView: 1,
      spaceBetween: 20
    },
    924: {
      slidesPerView: 2,
      spaceBetween: 20
    },
    1348: {
      slidesPerView: 3,
      spaceBetween: 20
    },
  },
};
</script>

<template>
  <div class="slideshow-container-gallery">
    <swiper
      v-bind="swiperOptions"
      :pagination="{ clickable: true }"
      :autoplay="{ delay: 3000, disableOnInteraction: false }"
      :modules="modules"
      class="mySwiperProducts">
      <swiper-slide v-for="(image, index) in gallery" :key="index">
        <div class="slide-card" @click="openModal(image.fullUrl)">
          <div class="image-wrapper">
            <img :src="image.fullUrl" :alt="'Slide ' + index" />
          </div>
        </div>
      </swiper-slide>
    </swiper>
    <Teleport to="body">
      <Transition name="fade">
        <div v-if="isModalOpen" class="modal-overlay" @click.self="closeModal">
          <div class="modal-container">
            <button class="close-button-gallery" @click="closeModal">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 25 25" fill="none">
                <path d="M0.30545 1.7803C0.20861 1.68346 0.131793 1.56849 0.079384 1.44196C0.0269748 1.31544
                1.02037e-09 1.17982 0 1.04287C-1.02037e-09 0.905921 0.0269748 0.77031 0.079384 0.643783C0.131793
                0.517255 0.20861 0.40229 0.30545 0.30545C0.40229 0.20861 0.517255 0.131793 0.643783 0.079384C0.77031
                0.0269748 0.905921 -1.02037e-09 1.04287 0C1.17982 1.02037e-09 1.31544 0.0269748 1.44196
                0.079384C1.56849 0.131793 1.68346 0.20861 1.7803 0.30545L12.5 11.0272L23.2197 0.30545C23.3165
                0.20861 23.4315 0.131793 23.558 0.079384C23.6846 0.0269748 23.8202 0 23.9571 0C24.0941 0 24.2297
                0.0269748 24.3562 0.079384C24.4827 0.131793 24.5977 0.20861 24.6946 0.30545C24.7914 0.40229
                24.8682 0.517255 24.9206 0.643783C24.973 0.77031 25 0.905921 25 1.04287C25 1.17982 24.973 1.31544
                24.9206 1.44196C24.8682 1.56849 24.7914 1.68346 24.6946 1.7803L13.9728 12.5L24.6946 23.2197C24.7914
                23.3165 24.8682 23.4315 24.9206 23.558C24.973 23.6846 25 23.8202 25 23.9571C25 24.0941 24.973 24.2297
                24.9206 24.3562C24.8682 24.4827 24.7914 24.5977 24.6946 24.6946C24.5977 24.7914 24.4827 24.8682
                24.3562 24.9206C24.2297 24.973 24.0941 25 23.9571 25C23.8202 25 23.6846 24.973 23.558 24.9206C23.4315
                24.8682 23.3165 24.7914 23.2197 24.6946L12.5 13.9728L1.7803 24.6946C1.68346 24.7914 1.56849 24.8682
                1.44196 24.9206C1.31544 24.973 1.17982 25 1.04287 25C0.905921 25 0.77031 24.973 0.643783
                24.9206C0.517255 24.8682 0.40229 24.7914 0.30545 24.6946C0.20861 24.5977 0.131793 24.4827 0.079384
                24.3562C0.0269748 24.2297 0 24.0941 0 23.9571C0 23.8202 0.0269748 23.6846 0.079384 23.558C0.131793
                23.4315 0.20861 23.3165 0.30545 23.2197L11.0272 12.5L0.30545 1.7803Z" fill="white"/>
              </svg>
            </button>
            <div class="modal-content-gallery">
              <img :src="selectedImage" alt="Imagem ampliada" />
            </div>
          </div>
        </div>
      </Transition>
    </Teleport>
  </div>
</template>

<style scoped>
.modal-overlay{
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.50);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  .modal-container {
    position: relative;
    width: auto;
    border: 2px solid #fff;
    height: 750px;
    background-color: rgba(0, 0, 0, 0.50);
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    @media (max-width: 820px) {
      width: 95vw;
      height: auto;
      aspect-ratio: 808 / 582;
    }
    .close-button-gallery{
      position: absolute;
      top: 15px;
      left: 15px;
      z-index: 10;
      border: none;
      font-size: 32px;
      width: 50px;
      height: 50px;
      background-color: rgba(0, 0, 0, 0.6);
      border-radius: 50%;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      line-height: 0;
      transition: background 0.2s;
    }
    .modal-content-gallery {
      width: 100%;
      height: 100%;
      img{
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
  }
}

.slide-card {
  .image-wrapper {
    img {
      filter: grayscale(100%);
      transition: filter 0.3s ease;
    }
  }

  &:hover {
    .image-wrapper {
      img {
        filter: grayscale(0%);
      }
    }
  }
}

</style>
